// Simple cookie getter to avoid import issues
function getCookieSimple(name) {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length);
    if (cookie.indexOf(nameEQ) === 0) {
      try {
        return JSON.parse(decodeURIComponent(cookie.substring(nameEQ.length, cookie.length)));
      } catch (e) {
        return null;
      }
    }
  }
  return null;
}

export default function authHeader() {
  // Get user data from cookie instead of localStorage
  const user = getCookieSimple('user');
  
  if (user && user.accessToken) {
    return { Authorization: user.accessToken }; // for Spring Boot back-end
    // return { 'x-access-token': user.accessToken };       // for Node.js Express back-end
  } else {
    return {};
  }
}
